var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheque(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8885 1.78832V14.9546C20.8885 15.6293 20.3412 16.1765 19.6666 16.1765H1.2224C0.547758 16.1765 0.000488281 15.6293 0.000488281 14.9546V1.78832C0.000488281 1.11368 0.547758 0.566406 1.2224 0.566406H19.6666C20.3412 0.566406 20.8885 1.11368 20.8885 1.78832ZM21.7774 3.67742H22.7731C23.4505 3.68119 23.9977 4.23008 23.9999 4.90688V18.0975C23.9999 18.7711 23.4467 19.3431 22.7731 19.3431H4.32139C3.64783 19.3431 3.11135 18.7711 3.11135 18.0975V17.0656H19.6476C20.8113 17.0656 21.7774 16.1362 21.7774 14.972V3.67742Z",
    fill: "url(#paint0_linear_2286_609)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.41551 5.05469H10.5505C10.8614 5.05469 11.114 5.30673 11.114 5.61815C11.114 5.92956 10.8619 6.18161 10.5505 6.18161H3.41551C3.10464 6.18161 2.85205 5.92956 2.85205 5.61815C2.85205 5.30673 3.1041 5.05469 3.41551 5.05469Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.474 11.6894H3.41551C3.10464 11.6894 2.85205 11.4374 2.85205 11.126C2.85205 10.8145 3.1041 10.5625 3.41551 10.5625H17.474C17.7849 10.5625 18.0374 10.8145 18.0374 11.126C18.0374 11.4374 17.7854 11.6894 17.474 11.6894Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.474 8.93552H3.41551C3.10464 8.93552 2.85205 8.68347 2.85205 8.37206C2.85205 8.06064 3.1041 7.80859 3.41551 7.80859H17.474C17.7849 7.80859 18.0374 8.06064 18.0374 8.37206C18.0374 8.68347 17.7854 8.93552 17.474 8.93552Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2286_609",
    x1: 0.000487924,
    y1: 19.3431,
    x2: 24.8343,
    y2: 18.1657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B92FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8764FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheque);
export default __webpack_public_path__ + "static/media/cheque.b4c840d6aa80ba956ebd0f4870c4842f.svg";
export { ForwardRef as ReactComponent };